<template>
  <div class="pa-4 scrap-marca-wrapper">
    <v-btn @click="$router.back()" class="back-btn mb-4">
      <v-icon left>mdi-arrow-left</v-icon>
      VOLVER
    </v-btn>
    <v-col lg="12" class="pa-0">
      <v-row justify="center">
        <v-col lg="12">
          <v-card class="modern-report-card elevation-2 mb-4">
            <!-- Header moderno con gradiente y botón de ayuda -->
            <div class="report-header-banner">
              <div class="d-flex align-center header-main-info">
                <div class="header-icon-box mr-3 flex-shrink-0">
                  <v-icon color="white">mdi-tag-multiple-outline</v-icon>
                </div>
                <div class="header-text-block">
                  <div
                    class="font-weight-bold white--text header-company-title"
                  >
                    Neumáticos en Scrap por Marca
                  </div>
                  <div class="header-report-subtitle">
                    Análisis y distribución mensual de neumáticos dados de baja
                    según marcas evaluadas
                  </div>
                </div>
              </div>

              <div
                class="header-help-btn ml-auto flex-shrink-0 d-flex align-center"
              >
                <!-- Chip resumen en cabecera si hay resultados -->
                <v-chip
                  v-if="visualizarGrafico && totalgeneral > 0"
                  small
                  class="d-none d-sm-inline-flex mr-2 summary-header-chip"
                >
                  <v-icon left x-small color="amber lighten-2">mdi-tire</v-icon>
                  Total Scrap: <strong>{{ totalgeneral }}</strong>
                </v-chip>

                <!-- Botón de ayuda -->
                <v-tooltip left>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                      class="mx-1 btn-circle-tooltip"
                      icon
                      dark
                      target="_blank"
                      :href="
                        global && global.helpdesk_url
                          ? global.helpdesk_url + 'reporte-scrap-marca'
                          : '#'
                      "
                      v-bind="attrs"
                      v-on="on"
                    >
                      <v-icon size="22" color="amber lighten-2"
                        >mdi-help-circle-outline</v-icon
                      >
                    </v-btn>
                  </template>
                  <span>¿Necesitas ayuda?</span>
                </v-tooltip>
              </div>
            </div>

            <!-- Cuerpo del Reporte -->
            <v-card-text class="pa-4 pa-md-5">
              <!-- Card de Filtros de Búsqueda -->
              <v-card
                class="dashboard-chart-card rounded-lg pa-0 overflow-hidden elevation-1"
              >
                <div
                  class="chart-subtitle-bar px-4 py-2 d-flex align-center justify-space-between flex-wrap"
                >
                  <div class="d-flex align-center">
                    <v-icon small color="primary" class="mr-2"
                      >mdi-filter-variant</v-icon
                    >
                    <span
                      class="font-weight-bold text-caption text-uppercase text--primary"
                    >
                      Filtros de Búsqueda
                    </span>
                  </div>

                  <div class="d-flex align-center" v-if="reporteConsultado">
                    <v-chip
                      x-small
                      color="primary lighten-4"
                      class="primary--text font-weight-bold"
                    >
                      <v-icon left x-small>mdi-check-circle</v-icon>
                      Filtro aplicado
                    </v-chip>
                  </div>
                </div>

                <div class="pa-4 pa-md-5">
                  <v-row align="center">
                    <!-- Año -->
                    <v-col cols="12" sm="6" md="3" lg="3">
                      <v-autocomplete
                        outlined
                        dense
                        hide-details="auto"
                        :items="Years"
                        v-model="Item.year"
                        label="Año *"
                        placeholder="Seleccione año"
                        @change="onMeses(Item.year)"
                        prepend-inner-icon="mdi-calendar"
                        class="field-custom"
                      ></v-autocomplete>
                    </v-col>

                    <!-- Mes inicial -->
                    <v-col cols="12" sm="6" md="3" lg="3">
                      <v-autocomplete
                        outlined
                        dense
                        hide-details="auto"
                        :items="Meses"
                        item-text="mes"
                        item-value="numero_mes"
                        v-model="Item.month_init"
                        label="Mes inicial *"
                        placeholder="Seleccione mes inicial"
                        prepend-inner-icon="mdi-calendar-start"
                        class="field-custom"
                      ></v-autocomplete>
                    </v-col>

                    <!-- Mes final -->
                    <v-col cols="12" sm="6" md="3" lg="3">
                      <v-autocomplete
                        outlined
                        dense
                        hide-details="auto"
                        :items="Meses"
                        item-text="mes"
                        item-value="numero_mes"
                        v-model="Item.month_end"
                        label="Mes final"
                        placeholder="Mes final (opcional)"
                        clearable
                        prepend-inner-icon="mdi-calendar-end"
                        class="field-custom"
                      ></v-autocomplete>
                    </v-col>

                    <!-- Botones de Acción (Consultar y Exportar) -->
                    <v-col
                      cols="12"
                      sm="6"
                      md="3"
                      lg="3"
                      class="d-flex align-center justify-end"
                    >
                      <v-btn
                        @click="consultarReporte()"
                        color="primary"
                        height="40"
                        class="filter-action-btn font-weight-bold flex-grow-1 mr-2 px-2"
                        :disabled="
                          !Item.year || !Item.month_init || cargandoReporte
                        "
                        :loading="cargandoReporte"
                      >
                        <v-icon left small>mdi-magnify</v-icon>
                        Consultar&nbsp;&nbsp;
                      </v-btn>

                      <v-btn
                        @click="exportarAExcel()"
                        color="success"
                        height="40"
                        class="filter-action-btn font-weight-bold flex-grow-1 px-2"
                        :disabled="
                          !Item.year || !Item.month_init || loadingExcel
                        "
                        :loading="loadingExcel"
                      >
                        <v-icon left small>mdi-file-excel</v-icon>
                        Exportar&nbsp;&nbsp;
                      </v-btn>
                    </v-col>
                  </v-row>
                </div>
              </v-card>

              <!-- Estado 1: Cargando datos -->
              <div
                v-if="cargandoReporte"
                class="chart-loading-state rounded-lg pa-10 d-flex flex-column align-center justify-center text-center my-4"
              >
                <v-progress-circular
                  indeterminate
                  size="52"
                  width="4"
                  color="primary"
                  class="mb-4"
                ></v-progress-circular>
                <div
                  class="text-subtitle-1 font-weight-bold grey--text text--darken-3 mb-1"
                >
                  Consultando neumáticos en scrap por marca...
                </div>
                <div class="text-caption grey--text text--darken-1">
                  Procesando datos mensuales, marcas registradas y porcentajes
                  de participación
                </div>
              </div>

              <!-- Estado 2: Sin consulta inicial -->
              <div
                v-else-if="!visualizarGrafico && !reporteConsultado"
                class="chart-empty-state rounded-lg pa-8 pa-md-12 d-flex flex-column align-center justify-center text-center my-4"
              >
                <div class="empty-state-icon-circle mb-4">
                  <v-icon size="48" color="primary lighten-1"
                    >mdi-tag-multiple-outline</v-icon
                  >
                </div>
                <h3
                  class="text-h6 font-weight-bold grey--text text--darken-3 mb-2"
                >
                  Consulte el análisis de scrap por marca
                </h3>
                <p
                  class="text-body-2 grey--text text--darken-1 max-width-480 mb-4"
                >
                  Seleccione el año y mes para obtener la distribución de
                  neumáticos dados de baja según marcas evaluadas y porcentajes
                  de participación.
                </p>
                <v-chip
                  outlined
                  small
                  color="primary"
                  class="font-weight-medium"
                >
                  <v-icon left x-small>mdi-filter-variant</v-icon>
                  Seleccione los filtros y presione "Consultar"
                </v-chip>
              </div>

              <!-- Estado 3: Sin registros encontrados para la búsqueda -->
              <div
                v-else-if="
                  !visualizarGrafico && reporteConsultado && !cargandoReporte
                "
                class="chart-empty-state rounded-lg pa-8 pa-md-12 d-flex flex-column align-center justify-center text-center my-4"
              >
                <div class="empty-state-icon-circle mb-4">
                  <v-icon size="48" color="amber darken-2"
                    >mdi-alert-circle-outline</v-icon
                  >
                </div>
                <h3
                  class="text-h6 font-weight-bold grey--text text--darken-3 mb-2"
                >
                  Sin datos de scrap encontrados
                </h3>
                <p
                  class="text-body-2 grey--text text--darken-1 max-width-480 mb-4"
                >
                  No se encontraron neumáticos en scrap registrados para las
                  marcas en el período seleccionado.
                </p>
              </div>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>

      <!-- Tabla Distribución Mensual por Marca -->
      <v-row justify="center" v-if="visualizarGrafico == true">
        <v-col lg="12">
          <v-card>
            <v-toolbar height="60" color="#545554" dark>
              Distribución mensual según marca de scrap
            </v-toolbar>
            <v-container class="pa-2 pa-sm-4">
              <div v-if="visualizarGrafico == true && existInfoScrap == true">
                <!-- Indicador de desplazamiento horizontal en celular -->
                <div
                  class="d-flex d-sm-none align-center text-caption primary--text mb-2 px-1"
                >
                  <v-icon x-small color="primary" class="mr-1">
                    mdi-gesture-swipe-horizontal
                  </v-icon>
                  <span>Desliza horizontalmente para ver todos los datos</span>
                </div>

                <v-data-table
                  dense
                  :headers="headersDistribucion"
                  :items="itemsDistribucion"
                  hide-default-footer
                  disable-pagination
                  disable-sort
                  :mobile-breakpoint="0"
                  class="elevation-1 tabla-distribucion-moderna letra-10"
                  no-data-text="No hay datos disponibles"
                >
                  <!-- Mes -->
                  <template v-slot:[`item.nombre`]="{ item }">
                    <span class="font-weight-bold grey--text text--darken-3">
                      {{ item.nombre }}
                    </span>
                  </template>

                  <!-- Total mes -->
                  <template v-slot:[`item.total_mes`]="{ item }">
                    <span class="black--text font-weight-bold">
                      {{ item.total_mes }}
                    </span>
                  </template>

                  <!-- Porcentaje mes -->
                  <template v-slot:[`item.porcentaje_mes`]="{ item }">
                    <span class="black--text font-weight-bold">
                      {{ item.porcentaje_mes }}
                    </span>
                  </template>

                  <!-- Filas de Totales en Pie de Tabla -->
                  <template v-slot:body.append>
                    <!-- Fila Total General -->
                    <tr class="fila-total-general">
                      <td class="text-center font-weight-bold py-2">
                        <div class="d-flex align-center justify-center">
                          <v-icon small color="primary" class="mr-1"
                            >mdi-sigma</v-icon
                          >
                          <span>Total general</span>
                        </div>
                      </td>
                      <td
                        v-for="(item, index) in totales_marca"
                        :key="'tot-' + index"
                        class="text-center font-weight-bold py-2"
                      >
                        <span class="black--text">
                          {{ item }}
                        </span>
                      </td>
                      <td class="text-center py-2">
                        <span class="black--text">
                          {{ totalgeneral }}
                        </span>
                      </td>
                      <td class="text-center py-2">
                        <span class="black--text"> 100% </span>
                      </td>
                    </tr>

                    <!-- Fila Porcentaje -->
                    <tr class="fila-porcentaje-general">
                      <td
                        class="text-center font-weight-bold py-2 text-caption grey--text text--darken-2"
                      >
                        % Participación
                      </td>
                      <td
                        v-for="(item, index) in totales_marca"
                        :key="'porc-' + index"
                        class="text-center py-2 text-caption font-weight-medium grey--text text--darken-3"
                      >
                        {{ calcularPorcentaje(item) }}
                      </td>
                      <td class="text-center py-2">
                        <span class="black--text font-weight-bold"> 100% </span>
                      </td>
                      <td class="text-center py-2 grey--text text--lighten-1">
                        -
                      </td>
                    </tr>
                  </template>
                </v-data-table>
              </div>
              <div v-else>
                <v-alert
                  colored-border
                  border="left"
                  color="orange darken-3"
                  icon="mdi-information-outline"
                  class="orange lighten-5 rounded-lg mb-4 pa-3 alert-icon-leyenda"
                  style="width: 100%"
                >
                  <v-row dense class="align-center">
                    <v-col cols="12">
                      <div class="d-flex align-center">
                        <div>
                          <span
                            class="grey--text text--darken-4 text-caption font-weight-medium"
                            >No se encontraron datos de neumáticos en
                            scrap.</span
                          >
                        </div>
                      </div>
                    </v-col>
                  </v-row>
                </v-alert>
              </div>
            </v-container>
          </v-card>
        </v-col>
      </v-row>

      <!-- Gráfico Pastel y Tabla Resumen por Marca -->
      <v-row justify="center" v-if="visualizarGrafico == true">
        <v-col lg="12">
          <v-card>
            <v-toolbar height="60" color="#545554" dark>
              Resumen de inspección de análisis de scrap por marca
            </v-toolbar>
            <v-container class="pa-4">
              <v-row
                align="center"
                v-if="visualizarGrafico == true && existInfoScrap == true"
              >
                <v-col cols="12" md="6" lg="6">
                  <GraficoPie
                    IdGrafico="grafico_pastel_marca_scrap"
                    :Labels="LabelsGraficoPie"
                    :DatosGrafico="DatosGraficoPie"
                    :BackgroundColor="coloresGrafico"
                    :ShowLegend="false"
                    Suffix="%"
                    Height="550px"
                    v-if="
                      visualizarGrafico == true && DatosGraficoPie.length > 0
                    "
                  />
                </v-col>
                <v-col cols="12" md="6" lg="6">
                  <div class="tabla-distribucion-moderna elevation-1">
                    <table class="letra-10" style="width: 100%">
                      <thead>
                        <tr>
                          <th style="width: 60px" class="text-center">Color</th>
                          <th class="text-left">Marca</th>
                          <th style="width: 85px" class="text-center">
                            Cantidad
                          </th>
                          <th style="width: 85px" class="text-center">
                            Porcentaje
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr v-for="(item, index) in ResumenMarcas" :key="index">
                          <td
                            class="text-center"
                            style="vertical-align: middle"
                          >
                            <span
                              :style="{
                                display: 'inline-block',
                                width: '18px',
                                height: '18px',
                                borderRadius: '4px',
                                backgroundColor: obtenerColorMarca(index),
                                verticalAlign: 'middle',
                                boxShadow: '0 1px 3px rgba(0,0,0,0.2)',
                                border: '1px solid rgba(0,0,0,0.15)',
                              }"
                            ></span>
                          </td>
                          <td
                            class="text-left font-weight-medium grey--text text--darken-3"
                          >
                            {{ item.marca }}
                          </td>
                          <td
                            class="text-center font-weight-bold grey--text text--darken-4"
                          >
                            {{ item.cantidad }}
                          </td>
                          <td
                            class="text-center font-weight-bold grey--text text--darken-4"
                          >
                            {{ item.porcentajeStr }}
                          </td>
                        </tr>
                        <tr class="fila-total-general">
                          <td class="text-center py-2">
                            <v-icon small color="primary">mdi-sigma</v-icon>
                          </td>
                          <td class="text-left font-weight-bold py-2">
                            Total general
                          </td>
                          <td class="text-center font-weight-bold py-2">
                            {{ totalgeneral }}
                          </td>
                          <td class="text-center font-weight-bold py-2">
                            100%
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </v-col>
                <v-col
                  cols="12"
                  md="12"
                  lg="12"
                  class="mt-2"
                  v-if="marcaMayorScrap"
                >
                  <v-alert
                    dense
                    text
                    color="info"
                    icon="mdi-information-outline"
                    class="mb-0 text-center"
                  >
                    El mayor porcentaje de neumáticos retirados fueron de la
                    marca
                    <strong>{{ marcaMayorScrap.marca }}</strong
                    >, con un alcance del
                    <strong>{{ marcaMayorScrap.porcentaje }}</strong
                    >.
                  </v-alert>
                </v-col>
              </v-row>
              <div v-else>
                <v-alert
                  colored-border
                  border="left"
                  color="orange darken-3"
                  icon="mdi-information-outline"
                  class="orange lighten-5 rounded-lg mb-4 pa-3 alert-icon-leyenda"
                  style="width: 100%"
                >
                  <v-row dense class="align-center">
                    <v-col cols="12">
                      <div class="d-flex align-center">
                        <div>
                          <span
                            class="grey--text text--darken-4 text-caption font-weight-medium"
                            >No se encontraron datos de neumáticos en
                            scrap.</span
                          >
                        </div>
                      </div>
                    </v-col>
                  </v-row>
                </v-alert>
              </div>
            </v-container>
          </v-card>
        </v-col>
      </v-row>

      <!-- Modal Próximamente Exportar -->
      <v-dialog v-model="dialogProximamente" max-width="400px">
        <v-card class="rounded-lg">
          <v-toolbar color="secondary" dark dense flat>
            <v-icon left>mdi-file-export-outline</v-icon>
            <span class="text-subtitle-1 font-weight-bold">Exportar</span>
            <v-spacer></v-spacer>
            <v-btn icon small @click="dialogProximamente = false">
              <v-icon small>mdi-close</v-icon>
            </v-btn>
          </v-toolbar>
          <v-card-text class="pa-6 text-center">
            <v-avatar color="orange lighten-5" size="64" class="mb-4">
              <v-icon size="36" color="orange darken-2"
                >mdi-clock-outline</v-icon
              >
            </v-avatar>
            <h3 class="text-h6 font-weight-bold grey--text text--darken-3 mb-2">
              Próximamente
            </h3>
            <p class="grey--text text--darken-1 text-body-2 mb-0">
              Esta opción de exportación estará disponible próximamente.
            </p>
          </v-card-text>
          <v-divider></v-divider>
          <v-card-actions class="pa-3 justify-end">
            <v-btn color="secondary" small @click="dialogProximamente = false">
              Cerrar
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-col>
  </div>
</template>

<script>
import { mapState, mapActions } from "vuex";
import { axios2 as axios } from "@/interceptor/useApi";
import GraficoPie from "@/components/GraficoPie.vue";
import global from "@/global";

export default {
  components: {
    GraficoPie,
  },
  data() {
    return {
      global,
      Item: {
        year: null,
        month_init: null,
        month_end: null,
      },
      Meses: [],
      LabelsGraficoPie: [],
      DatosGraficoPie: [],
      ResumenMarcas: [],
      coloresGrafico: [
        "rgb(255, 99, 132)",
        "rgb(27, 205, 249)",
        "rgb(218, 247, 166)",
        "rgb(255, 205, 86)",
        "rgb(27, 216, 176)",
        "rgb(253, 152, 37)",
        "rgb(254, 243, 80)",
        "rgb(179, 241, 238)",
        "rgb(125, 254, 80)",
        "rgb(54, 162, 235)",
        "#E91E63",
        "#9C27B0",
        "#673AB7",
        "#3F51B5",
        "#2196F3",
        "#00BCD4",
        "#009688",
        "#4CAF50",
        "#8BC34A",
        "#CDDC39",
        "#FFEB3B",
        "#FFC107",
        "#FF9800",
        "#FF5722",
        "#795548",
        "#607D8B",
        "#F06292",
        "#BA68C8",
        "#4DD0E1",
        "#81C784",
      ],
      cargandoReporte: false,
      loadingExcel: false,
      visualizarGrafico: false,
      existInfoScrap: false,
      dialogProximamente: false,
      totalgeneral: 0,
      totales_marca: [],
      reporteConsultado: false,
    };
  },
  computed: {
    ...mapState("cliente", ["Cliente"]),
    ...mapState("reportes", ["NeumaticosScrapMesMarca", "Marcas"]),
    ...mapState("reporteconsolidado", ["Years"]),

    marcaMayorScrap() {
      if (
        !this.ResumenMarcas ||
        this.ResumenMarcas.length === 0 ||
        this.totalgeneral === 0
      ) {
        return null;
      }

      const mayor = this.ResumenMarcas[0];
      if (!mayor || mayor.cantidad <= 0) {
        return null;
      }

      return {
        marca: mayor.marca,
        cantidad: mayor.cantidad,
        porcentaje: mayor.porcentajeStr,
      };
    },

    headersDistribucion() {
      const headers = [
        {
          text: "Mes",
          value: "nombre",
          align: "center",
          sortable: false,
          width: 95,
          class: "th-mes",
        },
      ];

      if (this.Marcas && this.Marcas.length > 0) {
        this.Marcas.forEach((item) => {
          headers.push({
            text: item.descripcion,
            value: "cantidad_marca_" + item.id,
            align: "center",
            sortable: false,
            width: 85,
            class: "th-marca",
          });
        });
      }

      headers.push(
        {
          text: "Total general",
          value: "total_mes",
          align: "center",
          sortable: false,
          width: 75,
          class: "th-total",
        },
        {
          text: "% Part.",
          value: "porcentaje_mes",
          align: "center",
          sortable: false,
          width: 70,
          class: "th-porcentaje",
        },
      );

      return headers;
    },

    itemsDistribucion() {
      if (
        !this.NeumaticosScrapMesMarca ||
        this.NeumaticosScrapMesMarca.length === 0
      ) {
        return [];
      }
      return this.NeumaticosScrapMesMarca.map((item) => {
        const row = { ...item };
        if (this.Marcas && this.Marcas.length > 0) {
          this.Marcas.forEach((m) => {
            row["cantidad_marca_" + m.id] =
              item["cantidad_marca_" + m.id] !== undefined &&
              item["cantidad_marca_" + m.id] !== null
                ? item["cantidad_marca_" + m.id]
                : 0;
          });
        }
        row.porcentaje_mes = this.calcularPorcentaje(item.total_mes);
        return row;
      });
    },
  },
  methods: {
    ...mapActions("cliente", ["ObtenerDatosCliente"]),
    ...mapActions("reportes", ["DatosReporteScrapMesMarca"]),
    ...mapActions("reporteconsolidado", ["cargarAnios"]),

    onMeses: async function (year) {
      this.Item.month_init = null;
      this.Item.month_end = null;
      this.visualizarGrafico = false;
      this.existInfoScrap = false;
      this.totales_marca = [];
      this.totalgeneral = 0;
      this.LabelsGraficoPie = [];
      this.DatosGraficoPie = [];
      this.ResumenMarcas = [];
      this.Meses = [];
      this.reporteConsultado = false;

      if (!year) return;

      try {
        const data = {
          id_cliente: localStorage.getItem("idcliente"),
          year: year,
        };
        const response = await axios.post("reporte/meses", data);
        if (
          response.data &&
          response.data.success &&
          response.data.success.datos
        ) {
          this.Meses = response.data.success.datos.map((element) => ({
            numero_mes: String(element.numero_mes),
            mes: element.mes,
            text: element.mes,
            value: String(element.numero_mes),
          }));
        }
      } catch (error) {
        console.error("Error al obtener meses:", error);
      }
    },

    consultarReporte: async function () {
      if (!this.Item.year || !this.Item.month_init) {
        return;
      }

      this.visualizarGrafico = false;
      this.existInfoScrap = false;
      this.totales_marca = [];
      this.totalgeneral = 0;
      this.LabelsGraficoPie = [];
      this.DatosGraficoPie = [];
      this.ResumenMarcas = [];
      this.cargandoReporte = true;
      this.reporteConsultado = true;

      try {
        const payload = {
          year: this.Item.year,
          month_init: this.Item.month_init,
          month_end: this.Item.month_end || this.Item.month_init,
        };

        await this.DatosReporteScrapMesMarca(payload);

        if (
          this.NeumaticosScrapMesMarca &&
          this.NeumaticosScrapMesMarca.length > 0
        ) {
          this.NeumaticosScrapMesMarca.forEach((element) => {
            this.totalgeneral += element.total_mes;
          });

          this.Marcas.forEach((element1) => {
            let cantidad = 0;
            this.NeumaticosScrapMesMarca.forEach((element2) => {
              cantidad += element2["cantidad_marca_" + element1.id] || 0;
            });
            this.totales_marca.push(cantidad);
          });

          let resumen = [];
          this.Marcas.forEach((element1, index) => {
            let cantidad = this.totales_marca[index] || 0;
            let porcentajeStr = this.calcularPorcentaje(cantidad);
            let total = this.totalgeneral == 0 ? 1 : this.totalgeneral;
            let porcentajeNum = parseFloat(
              ((cantidad / total) * 100).toFixed(2),
            );

            resumen.push({
              id: element1.id,
              marca: element1.descripcion,
              cantidad: cantidad,
              porcentajeStr: porcentajeStr,
              porcentajeNum: porcentajeNum,
            });
          });

          // Ordenar de mayor a menor por cantidad
          resumen.sort((a, b) => b.cantidad - a.cantidad);

          this.ResumenMarcas = resumen;

          resumen.forEach((item) => {
            this.LabelsGraficoPie.push(
              item.marca + " (" + item.porcentajeStr + ")",
            );
            this.DatosGraficoPie.push(item.porcentajeNum);
          });

          if (this.totalgeneral > 0) {
            this.existInfoScrap = true;
          }

          await this.$nextTick();
          this.visualizarGrafico = true;
        } else {
          this.visualizarGrafico = false;
          this.existInfoScrap = false;
        }
      } catch (error) {
        console.error("Error al consultar reporte:", error);
      } finally {
        this.cargandoReporte = false;
      }
    },

    calcularPorcentaje: function (cantidad) {
      let total = this.totalgeneral == 0 ? 1 : this.totalgeneral;
      let valor = (cantidad / total) * 100;

      if (valor != 100) {
        valor = valor.toFixed(2);
      }
      return valor + "%";
    },

    obtenerColorMarca(index) {
      return this.coloresGrafico[index % this.coloresGrafico.length];
    },

    _json_to_query_string: function (json) {
      json = Object.keys(json).map((item) => {
        return (
          item +
          "=" +
          (json[item] !== undefined && json[item] !== null ? json[item] : "")
        );
      });
      return json.join("&");
    },

    exportarAExcel: async function () {
      this.loadingExcel = true;
      try {
        const url =
          axios.defaults.baseURL +
          "excel/reportescrapmarca?" +
          this._json_to_query_string({
            id_cliente: localStorage.getItem("idcliente"),
            year: this.Item.year,
            month_init: this.Item.month_init,
            month_end: this.Item.month_end || this.Item.month_init,
          });

        const response = await axios({
          url: url,
          method: "GET",
          responseType: "blob",
        });

        // Obtener nombre de archivo desde Content-Disposition
        let nombre_archivo = "reporte.xlsx";
        const disposition = response.headers["content-disposition"];

        if (disposition) {
          // Priorizar UTF-8 si está disponible
          const utf8Match = disposition.match(/filename\*=UTF-8''([^;\n]*)/i);
          const asciiMatch = disposition.match(/filename="?([^;\n"]+)"?/i);

          if (utf8Match && utf8Match[1]) {
            nombre_archivo = decodeURIComponent(utf8Match[1]);
          } else if (asciiMatch && asciiMatch[1]) {
            nombre_archivo = asciiMatch[1];
          }
        }

        // Si el blob es HTML (error), mostrar alerta
        if (response.data.type === "text/html") {
          const text = await response.data.text();
          const res = JSON.parse(text);
          if (!res.exito) {
            alert(res.mensaje || "Ocurrió un error al generar el archivo.");
            return;
          }
        } else {
          // Descargar archivo
          const blob = new Blob([response.data]);
          const downloadUrl = window.URL.createObjectURL(blob);
          const link = document.createElement("a");
          link.href = downloadUrl;
          link.setAttribute("download", nombre_archivo);
          document.body.appendChild(link);
          link.click();
          link.remove();
        }
      } catch (error) {
        this.errorMessage = error.response?.data || "Error inesperado";
        console.error("Error al exportar a Excel:", error);
      } finally {
        this.loadingExcel = false;
      }
    },
  },
  mounted() {
    this.ObtenerDatosCliente();
    this.cargarAnios();
  },
};
</script>

<style scoped>
table {
  border-collapse: collapse;
}

td {
  vertical-align: top;
}

.border {
  border-style: solid;
  border-width: 1px;
}

.border-bottom {
  border-bottom: solid;
  border-width: 1px;
}

.border-top {
  border-top: solid;
  border-width: 1px;
}

.border-left {
  border-left: solid;
  border-width: 1px;
}

.border-right {
  border-right: solid;
  border-width: 1px;
}

.no-border {
  border-top: none;
  border-left: none;
  border-right: none;
  border-bottom: none;
}

.no-border-left {
  border-left: none;
}

.no-border-right {
  border-right: none;
}

.texto-cen {
  text-align: center;
}

.texto-izq {
  text-align: left;
}

.texto-just {
  text-align: justify;
}

.inline {
  display: inline-block;
}

.texto-arriba {
  vertical-align: text-top;
  vertical-align: top;
}

.letra-6 {
  font-size: 6pt;
}

.letra-7 {
  font-size: 7pt;
}

.letra-8 {
  font-size: 8pt;
}

.letra-9 {
  font-size: 9pt;
}

.letra-10 {
  font-size: 10pt;
}

.letra-11 {
  font-size: 11pt;
}

.letra-12 {
  font-size: 12pt;
}

.letra-14 {
  font-size: 14pt;
}

.letra-15 {
  font-size: 15pt;
}

.letra-18 {
  font-size: 18pt;
}

.letra-25 {
  font-size: 25pt;
}

.letra-30 {
  font-size: 30pt;
}

.margin-top-20 {
  margin-top: 20px;
}

.bg-celda-azul {
  background: #91e3da;
}

.bg-celda-amarilla {
  background: #faec5c;
  /*color:#EDDF04;*/
}

.bg-celda-verde {
  background: #a8fa6f;
}

.bg-celda-roja {
  background: #f55f50;
}

.tabla-distribucion-moderna {
  border-radius: 8px;
  overflow: hidden;
  border: 1px solid #e0e0e0;
  background: #ffffff;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.04);
}

.tabla-distribucion-moderna ::v-deep .v-data-table__wrapper {
  overflow-x: auto;
  -webkit-overflow-scrolling: touch;
  scrollbar-width: thin;
  scrollbar-color: #b0bec5 #f5f5f5;
}

.tabla-distribucion-moderna ::v-deep .v-data-table__wrapper::-webkit-scrollbar {
  height: 6px;
  width: 6px;
}

.tabla-distribucion-moderna
  ::v-deep
  .v-data-table__wrapper::-webkit-scrollbar-track {
  background: #f1f3f5;
  border-radius: 3px;
}

.tabla-distribucion-moderna
  ::v-deep
  .v-data-table__wrapper::-webkit-scrollbar-thumb {
  background: #b0bec5;
  border-radius: 3px;
}

.tabla-distribucion-moderna
  ::v-deep
  .v-data-table__wrapper::-webkit-scrollbar-thumb:hover {
  background: #78909c;
}

.tabla-distribucion-moderna ::v-deep table {
  border-collapse: separate;
  border-spacing: 0;
  width: 100%;
}

.tabla-distribucion-moderna ::v-deep .v-data-table__wrapper table {
  min-width: 800px;
}

.tabla-distribucion-moderna ::v-deep thead th {
  background-color: #545554 !important;
  color: #ffffff !important;
  font-size: 10.5px !important;
  font-weight: 600 !important;
  text-align: center;
  white-space: normal !important;
  word-break: break-word !important;
  overflow-wrap: break-word !important;
  hyphens: auto;
  line-height: 1.2 !important;
  padding: 8px 4px !important;
  height: auto !important;
  min-height: 42px !important;
  vertical-align: middle !important;
  border-right: 1px solid rgba(255, 255, 255, 0.15) !important;
  border-bottom: 2px solid rgba(0, 0, 0, 0.15) !important;
  text-transform: uppercase;
  letter-spacing: 0.2px;
}

.tabla-distribucion-moderna ::v-deep thead th.text-left,
.tabla-distribucion-moderna ::v-deep thead th.text-start {
  text-align: left !important;
}

.tabla-distribucion-moderna ::v-deep thead th.text-center {
  text-align: center !important;
}

.tabla-distribucion-moderna ::v-deep thead th.text-right,
.tabla-distribucion-moderna ::v-deep thead th.text-end {
  text-align: right !important;
}

.tabla-distribucion-moderna ::v-deep thead th span {
  display: inline-block;
  max-width: 100%;
  white-space: normal !important;
  word-break: break-word !important;
  line-height: 1.2;
}

.tabla-distribucion-moderna ::v-deep thead th:last-child {
  border-right: none !important;
}

.tabla-distribucion-moderna ::v-deep thead th.th-total,
.tabla-distribucion-moderna ::v-deep thead th.th-porcentaje {
  background-color: #3f403f !important;
  font-weight: 700 !important;
}

/* Sticky primera columna (Mes) */
.tabla-distribucion-moderna ::v-deep thead th:first-child {
  position: sticky !important;
  left: 0 !important;
  z-index: 4 !important;
  background-color: #3f403f !important;
  box-shadow: 2px 0 5px rgba(0, 0, 0, 0.15);
}

.tabla-distribucion-moderna ::v-deep tbody tr td:first-child {
  position: sticky !important;
  left: 0 !important;
  z-index: 2 !important;
  background-color: #ffffff;
  box-shadow: 2px 0 5px rgba(0, 0, 0, 0.05);
}

.tabla-distribucion-moderna ::v-deep tbody tr:hover td:first-child {
  background-color: #f5f7fa !important;
}

.tabla-distribucion-moderna
  ::v-deep
  tbody
  tr.fila-total-general
  td:first-child {
  position: sticky !important;
  left: 0 !important;
  z-index: 3 !important;
  background-color: #eceff1 !important;
  box-shadow: 2px 0 5px rgba(0, 0, 0, 0.08);
}

.tabla-distribucion-moderna
  ::v-deep
  tbody
  tr.fila-porcentaje-general
  td:first-child {
  position: sticky !important;
  left: 0 !important;
  z-index: 3 !important;
  background-color: #f8fafc !important;
  box-shadow: 2px 0 5px rgba(0, 0, 0, 0.08);
}

.tabla-distribucion-moderna ::v-deep tbody td {
  border-right: 1px solid #edf2f7;
  border-bottom: 1px solid #edf2f7 !important;
  font-size: 11px;
  padding: 6px 4px !important;
  text-align: center;
  font-variant-numeric: tabular-nums;
  white-space: nowrap;
}

.tabla-distribucion-moderna ::v-deep tbody td.text-left,
.tabla-distribucion-moderna ::v-deep tbody td.text-start {
  text-align: left !important;
}

.tabla-distribucion-moderna ::v-deep tbody td.text-center {
  text-align: center !important;
}

.tabla-distribucion-moderna ::v-deep tbody td.text-right,
.tabla-distribucion-moderna ::v-deep tbody td.text-end {
  text-align: right !important;
}

.tabla-distribucion-moderna ::v-deep tbody td:last-child {
  border-right: none;
}

.tabla-distribucion-moderna
  ::v-deep
  tbody
  tr:hover:not(.fila-total-general):not(.fila-porcentaje-general) {
  background-color: #f8fafc !important;
}

.fila-total-general {
  background-color: #eceff1 !important;
  border-top: 2px solid #cfd8dc !important;
  border-bottom: 1px solid #cfd8dc !important;
}

.fila-total-general td {
  font-weight: 700 !important;
  font-size: 11px !important;
  border-right: 1px solid #cfd8dc !important;
  border-bottom: 1px solid #cfd8dc !important;
  color: #1e293b;
}

.fila-total-general td:last-child {
  border-right: none !important;
}

.fila-porcentaje-general {
  background-color: #f8fafc !important;
  border-bottom: 2px solid #cfd8dc !important;
}

.fila-porcentaje-general td {
  font-weight: 600 !important;
  font-size: 10.5px !important;
  border-right: 1px solid #e2e8f0 !important;
  border-bottom: 2px solid #cbd5e1 !important;
  color: #334155;
}

.fila-porcentaje-general td:last-child {
  border-right: none !important;
}

/* Responsivo para tablets y pantallas medianas */
@media (max-width: 960px) {
  .tabla-distribucion-moderna ::v-deep thead th {
    font-size: 9.5px !important;
    padding: 6px 2px !important;
    min-height: 38px !important;
  }

  .tabla-distribucion-moderna ::v-deep tbody td {
    font-size: 10px !important;
    padding: 5px 2px !important;
  }

  .fila-total-general td,
  .fila-porcentaje-general td {
    font-size: 10px !important;
    padding: 5px 2px !important;
  }
}

/* Responsivo para móviles */
@media (max-width: 600px) {
  .tabla-distribucion-moderna ::v-deep .v-data-table__wrapper table {
    min-width: 750px;
  }

  .tabla-distribucion-moderna ::v-deep thead th {
    font-size: 9.5px !important;
    padding: 6px 3px !important;
    line-height: 1.15 !important;
    white-space: nowrap !important;
  }

  .tabla-distribucion-moderna ::v-deep tbody td {
    font-size: 10px !important;
    padding: 6px 3px !important;
    white-space: nowrap !important;
  }

  .fila-total-general td,
  .fila-porcentaje-general td {
    font-size: 10px !important;
    padding: 6px 3px !important;
    white-space: nowrap !important;
  }
}

#table {
  display: block;
  width: 100% !important;
  overflow-x: scroll;
}

/* =========================================================
   UI/UX STYLES - REPORTE SCRAP POR MARCA
   Basado en ReporteRemanenteRodadoVehiculo.vue
   ========================================================= */

.scrap-marca-wrapper {
  background-color: #f8fafc;
  min-height: 100%;
}

/* Botón Volver */
.back-btn {
  font-weight: 700;
  letter-spacing: 0.3px;
  border-radius: 8px;
  text-transform: none;
  transition: all 0.2s ease;
}

.back-btn:hover {
  transform: translateX(-2px);
}

/* Card y Header Modernos */
.modern-report-card {
  border-radius: 12px !important;
  border: 1px solid #e2e8f0 !important;
  overflow: hidden;
  background: #ffffff !important;
}

.report-header-banner {
  background: linear-gradient(135deg, #1e293b 0%, #334155 100%);
  padding: 14px 20px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 10px;
}

.header-main-info {
  flex: 1 1 0;
  min-width: 0;
  overflow: hidden;
}

.header-text-block {
  min-width: 0;
  overflow: hidden;
}

.header-help-btn {
  flex: 0 0 auto;
  flex-shrink: 0;
  white-space: nowrap;
}

.header-icon-box {
  width: 42px;
  height: 42px;
  min-width: 42px;
  background: rgba(255, 255, 255, 0.12);
  border: 1px solid rgba(255, 255, 255, 0.2);
  border-radius: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.15);
}

.header-company-title {
  font-size: 1.05rem;
  line-height: 1.25;
  letter-spacing: 0.3px;
  color: #ffffff;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.header-report-subtitle {
  color: #94a3b8;
  font-size: 0.78rem;
  font-weight: 500;
  margin-top: 2px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.summary-header-chip {
  background: rgba(255, 255, 255, 0.15) !important;
  border: 1px solid rgba(255, 255, 255, 0.25) !important;
  color: #ffffff !important;
  font-weight: 600;
  letter-spacing: 0.3px;
}

.btn-circle-tooltip {
  background: rgba(255, 255, 255, 0.16) !important;
  border: 1px solid rgba(255, 255, 255, 0.25) !important;
  border-radius: 50% !important;
  width: 36px !important;
  height: 36px !important;
  min-width: 36px !important;
  max-width: 36px !important;
  padding: 0 !important;
  margin: 0 !important;
  display: inline-flex !important;
  align-items: center !important;
  justify-content: center !important;
  text-decoration: none !important;
  transition: all 0.2s ease-in-out !important;
}

.btn-circle-tooltip:hover {
  background: rgba(255, 255, 255, 0.28) !important;
  border-color: rgba(255, 255, 255, 0.45) !important;
  transform: scale(1.06);
}

/* Card interna de Filtros */
.dashboard-chart-card {
  border: 1px solid #e2e8f0 !important;
  background-color: #ffffff;
  transition: transform 0.2s ease, box-shadow 0.25s ease, border-color 0.2s ease;
}

.dashboard-chart-card:hover {
  border-color: #cbd5e1 !important;
  box-shadow: 0 6px 18px rgba(0, 0, 0, 0.05) !important;
}

.chart-subtitle-bar {
  background: linear-gradient(180deg, #f8fafc 0%, #f1f5f9 100%);
  border-bottom: 1px solid #e2e8f0;
  font-size: 0.815rem;
  line-height: 1.35;
  min-height: 42px;
}

/* Campos de Formulario */
.field-custom ::v-deep .v-input__slot {
  background: #f8fafc !important;
  border-radius: 8px !important;
  transition: all 0.2s ease;
}

.field-custom ::v-deep .v-input__slot:hover {
  background: #ffffff !important;
}

.field-custom ::v-deep.v-input--is-focused .v-input__slot {
  background: #ffffff !important;
}

.filter-action-btn {
  border-radius: 8px !important;
  letter-spacing: 0.3px;
  text-transform: none;
  font-size: 0.875rem !important;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.08) !important;
}

/* Estados Vacío y Carga */
.chart-empty-state {
  min-height: 280px;
  background: #f8fafc;
  border: 1.5px dashed #cbd5e1;
}

.empty-state-icon-circle {
  width: 76px;
  height: 76px;
  border-radius: 50%;
  background: #eff6ff;
  border: 1px solid #bfdbfe;
  display: flex;
  align-items: center;
  justify-content: center;
}

.chart-loading-state {
  min-height: 280px;
  background: #ffffff;
  border: 1px solid #e2e8f0;
}

.max-width-480 {
  max-width: 480px;
  margin-left: auto;
  margin-right: auto;
}

/* ============================================================
   RESPONSIVE: Mobile (max 600px)
   ============================================================ */
@media (max-width: 600px) {
  .report-header-banner {
    padding: 12px 14px;
    gap: 8px;
  }

  .header-icon-box {
    width: 36px;
    height: 36px;
    min-width: 36px;
  }

  .header-company-title {
    font-size: 0.85rem !important;
  }

  .header-report-subtitle {
    font-size: 0.68rem !important;
  }
}
</style>
